import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationsService } from './services/notifications/notifications.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(
        private injector: Injector,
        private zone: NgZone
    ) {}

    handleError(error: Error | HttpErrorResponse): void {
        // Handle ChunkLoadError FIRST - happens when lazy-loaded modules fail to load
        const chunkFailedMessage = /Loading chunk [\d\w-]+ failed|ChunkLoadError/;
        
        if (error instanceof Error && chunkFailedMessage.test(error.message)) {
            console.warn('Chunk load failed, reloading application...');
            
            this.zone.run(() => {
                // Clear service worker cache to get fresh chunks
                if ('caches' in window) {
                    caches.keys().then(names => {
                        names.forEach(name => caches.delete(name));
                    });
                }
                
                // Reload the page to get fresh chunks
                window.location.reload();
            });
            
            return; // Don't process further
        }

        // Existing error handling below
        const notifier = this.injector.get(NotificationsService);
    
        if (error instanceof HttpErrorResponse) {
            notifier.openServerErrorDialog(
                error.error?.message || error?.message || 'Server issue'
            );
            console.error('HTTP Error:', error);
        } else {
            notifier.showClientError(error?.message || error?.toString() || 'Server issue');
            console.error('Client Error:', error);
        }
    }
}